export default "/images/shield-off.svg?97582b11bdb228c4af53428d081f3dad";